<bzg-modal-header>
  <span class="bmc-reset-confirmation__header bzg-modal__header">{{ data.title | translate | titlecase }}</span>
</bzg-modal-header>
<bzg-modal-content class="bmc-reset-confirmation__body">
  <span [innerHTML]="data.message | translate"></span>
</bzg-modal-content>
<bzg-modal-footer>
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ 'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="reset()" class="bmc-reset-btn">{{ data.button | translate}}
  </bzg-button-primary>
</bzg-modal-footer>